import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import { VehicleEditPage } from '@/features/fleet/vehicle-edit-page'

export const Route = createFileRoute('/_authenticated/fleet/$vehicle_id/edit')({
  params: {
    parse: ({ vehicle_id }) => ({ vehicle_id: parseUrlId(vehicle_id) }),
    stringify: ({ vehicle_id }) => ({ vehicle_id: formatUrlId('VH', vehicle_id) }),
  },
  component: VehicleEditPage,
})
